<template>
  <transition name="slide-up-down">
    <div v-if="userHasActionsThatNeedConfirmation" class="friskkollen-footer">
      <div v-if="awaitingConfirmation" class="ms-2 me-2">
        <div class="d-flex align-items-center justify-content-center mb-5 px-4">
          <i class="bi bi-exclamation-triangle-fill fs-3 text-primary me-3"></i>
          <span class="fs-3 me-5">
            {{ $tr(data.locales, 'steps.confirm.message') }}
          </span>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <button
            class="btn btn-secondary me-5"
            @click="awaitingConfirmation = false"
          >
            {{ $tr(data.locales, 'steps.confirm.button.cancel.title') }}
          </button>
          <button
            class="btn btn-primary me-5 d-flex align-items-center justify-content-center"
            @click="confirmActions"
          >
            <i class="bi bi-check2 me-2"></i>
            <span>
              {{ $tr(data.locales, 'steps.confirm.button.confirm.title') }}
            </span>
          </button>
        </div>
      </div>
      <div
        v-else
        class="d-flex align-items-center justify-content-center ms-2 me-2 px-4"
      >
        <span class="fs-3 me-5">
          {{
            $tr(data.locales, 'steps.info.message', {
              key: 'userActionsThatNeedConfirmationLength',
              value: userActionsThatNeedConfirmation.length
            })
          }}
        </span>

        <button
          class="btn btn-primary me-5 d-flex align-items-center"
          @click="awaitingConfirmation = true"
        >
          <i class="bi bi-check2 me-2"></i>
          <span>
            {{ $tr(data.locales, 'steps.info.button.proceed.title') }}
          </span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UserShouldConfirmActions',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    userHasActionsThatNeedConfirmation: {
      type: Boolean,
      default: false
    },
    userActionsThatNeedConfirmation: {
      type: Array,
      default: () => []
    }
  },
  emits: ['confirmActions'],
  data() {
    return {
      awaitingConfirmation: false
    }
  },
  methods: {
    confirmActions() {
      this.$emit('confirmActions')
    }
  }
}
</script>
